import { router } from "..";
import { getFenceAlarm } from "../api/fencealarms_{imei}";
import { getPrices } from "../api/prices";
import { deviceCard, formatSubscriptionStatus } from "../device/device_card";
import { locale, relativeTimeString, t } from "../locale";
import { addNotificationListener } from "../mobile";
import { state } from "../state";
import { keyValueParagraph } from "../view/components";
import { Html } from "../view/html";
import { MaterialDesign } from "../view/material_design";
import { getFencealarmWarnings } from "./fa_warnings";

/**
 * @param {Fencealarm} fa
 */
async function fencealarmCard(fa) {
	addNotificationListener("fencealarm", fa.Imei, () => {
		getFenceAlarm(fa.Imei).then((fa) => {
			state.fencealarms[fa.Imei] = fa;
			// refresh(fa)
		});
	});

	return deviceCard({
		deviceName: fa.Metadata.Name,
		deviceType: "fencealarm",
		productName: "FenceAlarm",
		warnings: getFencealarmWarnings(fa),
		lines: [
			keyValueParagraph(
				locale.string({
					enGB: "Device status",
					deDE: "Gerätestatus",
					frFR: "État de l'appareil",
					svSE: "Enhetsstatus",
				}),
			),
			keyValueParagraph(
				locale.string({
					enGB: "- Voltage",
					deDE: "- Spannung",
					frFR: "- Tension",
					svSE: "- Spänning",
				}),
				`${fa.LastReport.Data.Voltage} V`,
			),
			keyValueParagraph(
				locale.string({
					enGB: "- Alarm level",
					deDE: "- Alarmstufe",
					frFR: "- Niveau d'alarme",
					svSE: "- Larmnivå",
				}),
				`${fa.Config.AlarmLevel} V`,
			),
			keyValueParagraph(
				locale.string({
					enGB: "- Battery level",
					deDE: "- Batteriestand",
					frFR: "- Niveau de batterie",
					svSE: "- Batterinivå",
				}),
				`${fa.LastReport.Data.Battery}%`,
			),
			keyValueParagraph(
				locale.string({
					deDE: "- Signalstärke",
					enGB: "- Signal strength",
					frFR: "- Force de signal",
					svSE: "- Signalstyrka",
				}),
				`${fa.LastReport.Data.Rssi}%`,
			),
			keyValueParagraph(
				t("deviceCard.lastActive")(),
				relativeTimeString(fa.LastReport.Timestamp),
			),
			keyValueParagraph(locale.strings.subscription),
			keyValueParagraph(
				locale.string({
					enGB: "- Plan",
					deDE: "- Plan",
					frFR: "- Plan",
					svSE: "- Plan",
				}),
				await formatSubscriptionPlan(fa),
			),
			keyValueParagraph(...formatSubscriptionStatus(fa.Subscription)),
		],
		buttons: [
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "monitoring",
					onClick: () => router.jump(`/fencealarm/${fa.Imei}/logs`),
				}),
			),
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "settings",
					onClick: () => router.jump(`/fencealarm/${fa.Imei}`),
				}),
			),
		],
	});
}

/**
 * @param {Fencealarm} fa
 */
async function formatSubscriptionPlan(fa) {
	if (fa.Subscription.Trialing) return locale.strings.trial;

	const { FencealarmMonth, FencealarmYear } = await getPrices();

	switch (fa.Subscription.PriceIds.Current) {
		case FencealarmMonth.Id:
			return locale.string({
				deDE: "Monatlich",
				enGB: "Monthly",
				frFR: "Mensuel",
				svSE: "Månadsvis",
			});
		case FencealarmYear.Id:
			return locale.string({
				deDE: "Jährlich",
				enGB: "Yearly",
				frFR: "Annuel",
				svSE: "Årsvis",
			});
	}

	const expiryTime = new Date(fa.Subscription.ExpiresAt);
	if (Date.now() < expiryTime.getTime()) return "";

	return locale.strings.none;
}

export { fencealarmCard };
